import { render } from "./packages.vue?vue&type=template&id=10cb7f40&scoped=true"
import script from "./packages.vue?vue&type=script&lang=js"
export * from "./packages.vue?vue&type=script&lang=js"

import "./packages.vue?vue&type=style&index=0&id=10cb7f40&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cb7f40"]])

export default __exports__